import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('sharedFilesV2');

export default resourceActions;
